import store from '../../store'

export default {
  bind(el, binding, vnode) {

  },
  inserted(el, binding, vnode) {
    const authorizesInfo = store.state.authorizesInfo || localStorage.authorizesInfo

    if (authorizesInfo.allAuthorizes) { return }
    // if (true) { return }

    const hasPermission = () => {
      const str = binding.value.menuCode
      if (!str) return false
      const arr = str.split(',')
      for (let i in arr) {
        if (authorizesInfo.authorizes) {
          const menuAuths = authorizesInfo.authorizes[arr[i]]

          if (!menuAuths || menuAuths.length === 0) { continue }
          // if (binding.value.authCode === '新增按钮') {
          //   debugger
          // }
          if (menuAuths.some(auth => auth === binding.value.authCode)) {
            return true
            break
          }
        }
      }
      return false
    }

    if (hasPermission()) { return }
    el.parentNode && el.parentNode.removeChild(el)
  }
}
